<template>
  <b-form-group
    :label="$t('projects.form.targetDate')"
    label-for="target_date"
  >
    <b-input-group>
      <b-form-datepicker
        id="target_date"
        v-model="dataItem.target_date"
        v-bind="datepickerProps"
        :placeholder="$t('fields.selectDate')"
        :min="minDate"
      />
      <template #append>
        <b-button
          variant="warning"
          @click="dataItem.target_date = null"
        >
          <feather-icon icon="XIcon" />
        </b-button>
      </template>
    </b-input-group>
    <b-alert
      v-if="isEditMode && isPastDate"
      show
      variant="warning"
      class="mt-1 mb-0"
    >
      <div class="alert-body">
        {{ $t('projects.form.pastDateWarning') }}
      </div>
    </b-alert>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormDatepicker, BAlert, BInputGroup, BButton,
} from 'bootstrap-vue'
import { datepickerLocale } from '@/libs/i18n/datepicker'

export default {
  name: 'ProjectsTargetDateCard',
  components: {
    BFormGroup,
    BFormDatepicker,
    BAlert,
    BInputGroup,
    BButton,
  },
  mixins: [datepickerLocale],
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
    isEditMode() {
      return !!this.dataItem.id
    },
    isPastDate() {
      if (!this.dataItem.target_date) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const target = new Date(this.dataItem.target_date)
      target.setHours(0, 0, 0, 0)
      return target < today
    },
    minDate() {
      if (this.isEditMode) return null
      return new Date().toISOString().split('T')[0]
    },
  },
}
</script>
